export default __webpack_public_path__ + "static/media/Hero-IMG.f17ea512.png";